import React, { ReactNode } from "react";
import {
    Box,
    Paper,
    Avatar,
    styled,
 } from "@mui/material";
import theme from "../utils/theme";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import loginImg from '../assets/img/login1.jpg'

interface AuthLayoutProps {
  children: ReactNode;
}

const AuthLayout: React.FC<AuthLayoutProps> = ({ children }) => {
    const GlassCard = styled(Paper)(({ theme }) => ({
        backdropFilter: "blur(10px)",
        backgroundColor: "rgba(255, 255, 255, 0.2)",
        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
        border: "1px solid rgba(255, 255, 255, 0.3)",
        borderRadius: "16px",
        padding: theme.spacing(2),
        width: "90%",
        maxWidth: "400px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        zIndex: 2
      }));
      
    const Overlay = styled("div")({
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        width: "300px",
        height: "200px",
        backgroundColor: "rgba(255, 255, 255, 0.8)",
        zIndex: 1,
    });

  return (
    <Box
      sx={{
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        position: "relative",
        backgroundImage: `url(${loginImg})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <Overlay />
      <GlassCard elevation={5}>
        <Avatar sx={{ bgcolor: theme.palette.primary.main, mb: 2 }}>
          <LockOutlinedIcon />
        </Avatar>
        {children}
      </GlassCard>
    </Box>
  );
};

export default AuthLayout;
